import type {
  ComicPerformanceMetricId,
  ComicPerformanceSeries,
} from '../content';

export const comicPerformanceBenchmark = {
  metadata: {
    benchmark: 'Historical EMDB benchmark',
    date: 'September 4, 2026',
    frameCount: 62707,
    source: 'radar.html#radar-data',
    clipCount: 39,
    caveat: 'Predates later MHR audit corrections.',
    methodology:
      'Error axes use 100 × clip(1 − value/cap, 0, 1) with the original generator default cap of 1.25 × the worst selected model. Speed uses a logarithmic 0.01×–1× realtime range.',
    caps: {
      accel: 25.97,
      fs: 96.34,
      jitter: 63.71,
      pa_mpjpe: 66.31,
      rte: 15.87,
      wa2_mpjpe: 1410.7,
      waa_mpjpe: 646.99,
    },
  },
  models: [
    {
      id: 'comic-4',
      label: 'Comic 4',
      sourceId: 'anchor2',
      successfulClips: 39,
      rawValues: {
        'pose-accuracy': 51.57735400370621,
        'motion-fidelity': 3.223519476597567,
        'world-accuracy': 118.02617934194032,
        trajectory: 264.7392839278551,
        'root-drift': 3.1911370052852575,
        smoothness: 15.887264904271067,
        'foot-contact': 4.405438813529933,
        speed: 0.05453107535686988,
      },
      scores: {
        'pose-accuracy': 22.217834408526304,
        'motion-fidelity': 87.58752608164203,
        'world-accuracy': 81.75765014266985,
        trajectory: 81.23348097200999,
        'root-drift': 79.89201634980934,
        smoothness: 75.06315350137959,
        'foot-contact': 95.42719658134739,
        speed: 36.83220310454075,
      },
    },
    {
      id: 'comic-realtime',
      label: 'Comic Realtime',
      sourceId: 'moro_static',
      successfulClips: 39,
      rawValues: {
        'pose-accuracy': 51.682221221551146,
        'motion-fidelity': 20.77783135193585,
        'world-accuracy': 517.5912297656366,
        trajectory: 1128.5578169500566,
        'root-drift': 12.697885936840478,
        smoothness: 50.97176448493995,
        'foot-contact': 77.07270315013602,
        speed: 0.2849402487473343,
      },
      scores: {
        'pose-accuracy': 22.05968749577568,
        'motion-fidelity': 19.99294820201829,
        'world-accuracy': 20.00011904888227,
        trajectory: 20.00015474941118,
        'root-drift': 19.988116340009586,
        smoothness: 19.994091218113397,
        'foot-contact': 19.999270136873548,
        speed: 72.73768995482615,
      },
    },
    {
      id: 'comic-3',
      label: 'Comic 3',
      sourceId: 'comic3',
      successfulClips: 38,
      rawValues: {
        'pose-accuracy': 53.04470412598508,
        'motion-fidelity': 5.152891031433464,
        'world-accuracy': 133.20974296699885,
        trajectory: 306.45339512663196,
        'root-drift': 3.4083647749072874,
        smoothness: 24.70758775940837,
        'foot-contact': 3.109557939814934,
        speed: 0.055861359924446144,
      },
      scores: {
        'pose-accuracy': 20.004970402676705,
        'motion-fidelity': 80.15829406456116,
        'world-accuracy': 79.41084978639564,
        trajectory: 78.27650137331594,
        'root-drift': 78.52322133013682,
        smoothness: 61.21866620717569,
        'foot-contact': 96.77230855323342,
        speed: 37.355575211727334,
      },
    },
  ] satisfies (ComicPerformanceSeries & { successfulClips: number })[],
};

export function formatBenchmarkRawValue(
  metricId: ComicPerformanceMetricId,
  value: number,
  unit: string,
) {
  return metricId === 'speed'
    ? `${value.toFixed(3)}×`
    : metricId === 'smoothness'
      ? `${value.toFixed(2)} (${unit})`
      : `${value.toFixed(2)} ${unit}`;
}

// The compact tooltip puts units in its heading instead of repeating each row.
export function formatBenchmarkTooltipValue(
  metricId: ComicPerformanceMetricId,
  value: number,
) {
  return value.toFixed(metricId === 'speed' ? 3 : value < 10 ? 2 : 1);
}
